import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { convertToSlug } from "../../utils/helps";
import {
  saveCategoty,
  updateCategory,
} from "../../features/admin/CategorySlice";

const categorySchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .min(3, "Tên danh mục phải ít nhất 3 ký tự")
    .required("Tên danh mục không được để trống"),
  // description: Yup.string().trim().required("Mô tả không được để trống"),
  // type: Yup.string()
  //   .oneOf(["category", "post", "company"], "Loại danh mục không hợp lệ")
  //   .required("Loại danh mục không được để trống"),
  permissions: Yup.array().min(1, "Chọn ít nhất một quyền"),
});

export default function CategoryModal({
  category,
  isOpen,
  onClose,
  types,
  tab,
}) {
  const dispatch = useDispatch();
  const { status: saveStatus, error } = useSelector((state) => state.roles);
  const { permissionsCate } = useSelector((state) => state.roles);
  const { categories } = useSelector((state) => state.categories);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [parentId, setParentId] = useState(null);
  const [priority, setPriority] = useState(0);
  const [type, setType] = useState(tab);
  const [isComment, setIsComment] = useState(false);
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (category) {
      setName(category.name || "");
      setDescription(category.description || "");
      setType(category.type || "category");
      setIsComment(category.isComment || false);
      setSelectedPermissions([category?.permissionId || ""] || []);
    } else {
      setName("");
      setDescription("");
      setType(tab || "category");
      setIsComment(false);
      setSelectedPermissions([]);
    }
  }, [category, tab]);

  const togglePermission = (id, children = []) => {
    setErrors((prev) => ({ ...prev, permissions: "" }));

    setSelectedPermissions((prev) => {
      if (prev.includes(id)) {
        return [];
      } else {
        return [id, ...children];
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let data = {
      name: name || "",
      slug: convertToSlug(name),
      description: description || "",
      type: type || "",
      // permissionId: selectedPermissions?.[0] || 0,
      parentId: Number(parentId) === 0 ? null : Number(parentId),
      priority: Number(priority) || 0,
      isComment: isComment || false,
      ...(selectedPermissions?.length > 0
        ? { permissionId: selectedPermissions[0] }
        : {}),
      ...(type === "post" || type === "navbar"
        ? { permissions: selectedPermissions }
        : {}),
    };

    try {
      await categorySchema.validate(data, { abortEarly: false });

      if (category?.id) {
        let dataUpdate = {
          ...data,
        };

        await dispatch(
          updateCategory({ id: category.id, dataUpdate: dataUpdate })
        ).unwrap();
        toast.success("Cập nhật danh mục thành công!");
      } else {
        await dispatch(saveCategoty(data)).unwrap();
        toast.success("Tạo danh mục thành công!");
      }

      onClose();
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const formErrors = {};
        error.inner.forEach((err) => {
          formErrors[err.path] = err.message;
        });
        setErrors(formErrors);
      } else {
        if (error.messages === "Slug đã tồn tại") {
          toast.error("Tên danh mục đã tồn tại");
        } else {
          toast.error(error.messages);
        }
      }
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center">
      <div className="bg-base-100 p-6 rounded-md w-1/2">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold mb-4">
            {category?.id ? "Chỉnh sửa danh mục" : "Tạo danh mục"}
          </h2>

          <button
            onClick={onClose}
            className="px-4 py-2 border rounded-md shadow-sm text-sm font-medium text-base-700 bg-base-100 hover:bg-base-200"
          >
            X
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-8">
              <label htmlFor="name" className="block text-sm font-medium">
                Tên danh mục<i className="text-red-600"> *</i>
              </label>
              <input
                type="text"
                placeholder="Nhập tên danh mục"
                value={name}
                onChange={(e) => {
                  setErrors((prev) => ({ ...prev, name: "" }));
                  setName(e.target.value);
                }}
                className="input input-bordered w-full mb-4"
              />
              {errors.name && (
                <p className="text-red-500 text-sm">{errors.name}</p>
              )}
            </div>
            <div className="col-span-4">
              <label className="block text-sm font-medium">Loại danh mục</label>
              <select
                value={type}
                onChange={(e) => setType(e.target.value)}
                className="select select-bordered w-full mb-4"
              >
                {types?.map((type) => (
                  <option key={type.value} value={type.value}>
                    {type.title}
                  </option>
                ))}
              </select>
              {errors.type && (
                <p className="text-red-500 text-sm">{errors.type}</p>
              )}
            </div>
          </div>
          <label className="flex items-center gap-2 font-semibold mb-2">
            <input
              type="checkbox"
              className="checkbox checkbox-info"
              checked={isComment}
              onChange={() => setIsComment(!isComment)}
            />
            Bình luận
          </label>

          <label htmlFor="description" className="block text-sm font-medium">
            Mô tả
          </label>
          <input
            type="text"
            placeholder="Nhập mô tả"
            value={description}
            onChange={(e) => {
              setErrors((prev) => ({ ...prev, description: "" }));
              setDescription(e.target.value);
            }}
            className="input input-bordered w-full mb-4"
          />
          {errors.description && (
            <p className="text-red-500 text-sm">{errors.description}</p>
          )}
          <div
            className={
              type === "post" || type === "navbar" || type === "notification"
                ? "block"
                : "hidden"
            }
          >
            <h3 className="text-lg font-medium">
              Chọn quyền<i className="text-red-600"> *</i>
            </h3>
            {errors.permissions && (
              <p className="text-red-500 text-sm">{errors.permissions}</p>
            )}
            <div className="grid grid-cols-2 gap-4">
              {permissionsCate?.map((group) => (
                <div>
                  <label className="flex items-center gap-2 font-semibold">
                    <input
                      type="checkbox"
                      className="checkbox checkbox-info"
                      checked={selectedPermissions.includes(group.id)}
                      onChange={() => togglePermission(group.id)}
                    />
                    {group.permissionName}
                  </label>
                </div>
              ))}
            </div>
          </div>
          <div className="flex justify-end space-x-4">
            <button type="button" className="btn btn-sm" onClick={onClose}>
              Hủy
            </button>
            <button
              type="submit"
              className="btn btn-primary btn-sm"
              disabled={saveStatus === "loading"}
            >
              {saveStatus === "loading"
                ? "Đang lưu..."
                : category?.id
                ? "Cập nhật"
                : "Tạo"}
            </button>
          </div>
          {error && (
            <p className="text-red-500 text-sm mt-2">
              Đã xảy ra lỗi: {error.message}
            </p>
          )}
        </form>
      </div>
    </div>
  );
}
